import { render, staticRenderFns } from "./PharmacyGroupsDataTable.vue?vue&type=template&id=41d652d4"
import script from "./PharmacyGroupsDataTable.vue?vue&type=script&lang=js"
export * from "./PharmacyGroupsDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports